import { useSelector } from 'react-redux'
import { IconButton } from '../../../../../common/components/iconButton/IconButton'
import { PromoInterface } from '../../../../../common/types/interfaces'
import classes from './Item.module.sass'
import { selectDarkTheme } from '../../../../../store/slices/settingsSlice'
import { shortenText } from '../../../../../common/utils/functions/shortenText'
import edit from '../../../../../assets/images/icons/edit.svg'
import search from '../../../../../assets/images/icons/search.svg'
import mail from '../../../../../assets/images/icons/mail.svg'
import { selectClusterImageUrl } from '../../../../../store/slices/currentClusterSlice'

type Props = {
  startEdit: (el: PromoInterface) => void
  startMailing: (el: PromoInterface) => void
  el: PromoInterface
  showDetails: (el: PromoInterface) => void
}

export const Item = ({ startEdit, el, showDetails, startMailing }: Props) => {
  const darkTheme = useSelector(selectDarkTheme)
  const imageUrl = useSelector(selectClusterImageUrl)

  // Ищем первый файл, который не является видео и не постером
  const firstImagePath = el.files.find(
    (path) => !path.includes('video_') && !path.includes('poster_'),
  )

  // Если есть картинка — показываем её, иначе показываем постер (если есть) или ничего
  const previewImage = firstImagePath
    ? `${imageUrl + firstImagePath}`
    : el.files.find((path) => path.includes('poster_'))
      ? `${imageUrl + el.files.find((path) => path.includes('poster_'))}`
      : null

  const visibleFiles = el.files.filter((path) => !path.includes('poster_'))
  const fileCount = visibleFiles.length

  const mailingStatus = el.mailingSummary?.status
  const isMailingDisabled = mailingStatus && mailingStatus !== 'not_started'

  const getStatusText = () => {
    switch (mailingStatus) {
      case 'in_progress':
        return '📧 Идёт рассылка'
      case 'completed':
        return '✅ Рассылка завершена'
      default:
        return null
    }
  }

  return (
    <div className={darkTheme ? classes.containerDark : classes.container}>
      <div className={classes.contentContainer}>
        {previewImage && <img className={classes.image} src={previewImage} alt={el.name} />}
        <div className={classes.filesLengthAnchor}>
          <div className={classes.filesLength}>{fileCount}</div>
        </div>
        <div className={classes.nameAndDescription}>
          <div className={classes.name}>{shortenText(el.name, 50)}</div>
          <div className={classes.description}>{shortenText(el.description, 100)}</div>
          {getStatusText() && <div className={classes.status}>{getStatusText()}</div>}
        </div>
        <div className={classes.sort}>{el.sortOrder !== 0 ? el.sortOrder : ''}</div>
      </div>
      <div className={classes.buttons}>
        <IconButton display onClick={() => showDetails(el)} icon={search} alt="Детали" small />
        <IconButton display onClick={() => startEdit(el)} icon={edit} alt="Изменить" small />
        <IconButton
          display
          onClick={() => startMailing(el)}
          icon={mail}
          alt="Начать рассылку"
          small
          disabled={isMailingDisabled}
        />
      </div>
    </div>
  )
}
